import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources, SupportedLanguage } from "./resources";
import type { TranslationOverride } from "../api/translations";

export const LANGUAGE_STORAGE_KEY = "obviowms.language";
export const supportedLanguages: SupportedLanguage[] = ["fr", "en"];

export function normalizeLanguage(language: unknown): SupportedLanguage | null {
  if (typeof language !== "string") {
    return null;
  }
  const normalized = language.trim().toLowerCase().split(/[-_]/)[0];
  return supportedLanguages.includes(normalized as SupportedLanguage)
    ? normalized as SupportedLanguage
    : null;
}

export function resolveInitialLanguage(): SupportedLanguage {
  const stored = window.localStorage.getItem(LANGUAGE_STORAGE_KEY)?.toLowerCase();
  const storedLanguage = normalizeLanguage(stored);
  if (storedLanguage) {
    return storedLanguage;
  }
  return normalizeLanguage(window.navigator.language) ?? "fr";
}

void i18n.use(initReactI18next).init({
  resources,
  lng: resolveInitialLanguage(),
  fallbackLng: "fr",
  supportedLngs: supportedLanguages,
  interpolation: { escapeValue: false },
  returnNull: false
});

export async function changeLanguage(language: SupportedLanguage) {
  window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
  await i18n.changeLanguage(language);
  document.documentElement.lang = language;
}

export function applyTranslationOverrides(overrides: TranslationOverride[]) {
  overrides.forEach((entry) => {
    i18n.addResource(entry.language, "translation", entry.key, entry.value);
  });
}

document.documentElement.lang = i18n.resolvedLanguage ?? "fr";

export default i18n;
